import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { inputStyles } from "../../styles/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import { Box, useMediaQuery, useTheme } from "@material-ui/core";

import BaseTextField from "./BaseTextField";
import CountDown from "./CountDown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { validateOTP } from "../../store/global/thunkActions";
import { otpMask } from "./TextMask";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function OtpModal(props) {
  const classes = inputStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  const [value, setValue] = useState("");

  const [time, setTime] = useState(60);
  const [timer, setTimer] = useState();

  useEffect(() => {
    if (props.open) {
      if (
        props.global.otpInfo?.expireSecond &&
        props.global.otpInfo.expireSecond !== ""
      ) {
        setTime(parseInt(props.global.otpInfo.expireSecond));
      }
      setValue("");
      startTimer();
    } else {
      stopTimer();
    }
  }, [props.open]);

  const startTimer = () => {
    const timer = setInterval(() => {
      setTime((prevState) => {
        if (prevState <= 0) {
          stopTimer();
          return 0;
        } else {
          return prevState - 1;
        }
      });
    }, 1000);

    setTimer(timer);
  };
  const stopTimer = () => {
    setTimer((prevState) => {
      clearInterval(prevState);
      return null;
    });
    handleClose();
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleVerify = () => {
    props.actions
      .validateOTP({
        otpOID: props.global.otpInfo.otpOID,
        otpReference: props.global.otpInfo.otpReference,
        otpType: props.otpType,
        otpKey: value,
        externalId: props.uuid,
        identityNo: props.tckn,
        taxNumber: props.taxNumber,
        companyCode: props.processContext.companyCode,
        phoneNumber: props.phoneNumber?.length === 10 ? props.phoneNumber : ''
      })
      .then((res) => {
        if (res) {
          handleClose();
        }
      });
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        maxWidth={"xs"}
        fullWidth
        fullScreen={fullScreen}
        scroll="body"
      >
        <DialogTitle onClose={handleClose}></DialogTitle>
        <DialogContent
          style={{ display: "block", minHeight: "20vh", textAlign: "center" }}
        >
          <Box style={{ margin: 30 }}>
            <p className={classes.header}>
              {props.global.otpInfo.pushDelivery !== "1"
                ? "Tek kullanımlık OTP kodunuzu giriniz."
                : "Kredi başvuru işlemine devam edebilmek için lütfen " +
                  props.global.otpInfo?.deviceName +
                  " cep telefonunuza " +
                  props.global.otpInfo?.otpReference +
                  " referans koduyla iletilen bildirimi onaylayınız. Eğer bildirim gelmediyse lütfen Fibabanka Mobil uygulamanızı açınız."}
            </p>
          </Box>
          <Box
            style={{ margin: 30, display: "flex", justifyContent: "center" }}
          >
            {props.global.otpInfo.pushDelivery !== "1" && (
              <BaseTextField
                value={value}
                autoFocus
                onChange={(ev) => setValue(ev.target.value)}
                InputProps={{
                  inputComponent: otpMask,
                }}
                inputProps={{ className: classes.otpInput }}
                style={{ textAlign: "center", width: "50%", fontSize: 20 }}
              />
            )}

            <CountDown time={time} />
          </Box>
          <Box style={{ margin: 10 }}>
            <Button
              variant={"contained"}
              onClick={handleVerify}
              color="primary"
            >
              {props.global.otpInfo.pushDelivery !== "1"
                ? "Doğrula"
                : "Kontrol Et"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    global: state.global,
    processContext: state.processContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      validateOTP: bindActionCreators(validateOTP, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpModal);
